import CalendarSection from "./CalendarSection";
import CupSection from "./CupSection";
import { ADSWrapper, Wrapper } from "./ChallengeSudoku.components";
import AdsDesktopPanel from "../AdsDesktopPanel";

const ChallengeSudoku: React.FC = () => {
  return (
    <ADSWrapper>
      <Wrapper>
        <CupSection />
        <CalendarSection />
      </Wrapper>

      <AdsDesktopPanel />
    </ADSWrapper>
  );
};

export default ChallengeSudoku;
